/** @format */

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Chain, Environment } from '@shared/data-access/interfaces';

import { map, retry } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class MarketingDao {
	readonly ESPOT_BY_NAME_STATE_KEY_PREFIX = 'espot-';
	readonly FOOTER_CMS_STATE_KEY_PREFIX = 'footer-cms-content';
	readonly HOMR_TEMPLATE_STATE_KEY_PREFIX = 'homr-template-';

	constructor(
		private chain: Chain,
		private environment: Environment,
		private http: HttpClient,
		@Inject(PLATFORM_ID) protected platformId: any
	) {}

	/**
	 * @desc Registers the given email address with Loyalty.
	 *
	 * @param email - The email address that gets registered with Loyalty
	 * @param retries - number of retries
	 * @returns - {Observable<any>} Future Object to be resolved or rejected
	 */
	public registerEmailAddressForLoyaltyFNS$(email, retries = 0) {
		const reqData = {
			emailId: email
		};

		// HTTP Headers
		const httpHeaders = new HttpHeaders({
			'Content-Type': 'application/json',
			'x-CentraSite-APIKey': this.environment.apiTokens.esb.myaccount,
			Env: this.environment.esbEnvironmentHeader
		});

		// HTTP Options
		const httpOptions = {
			headers: httpHeaders,
			withCredentials: true
		};

		const url = `${this.environment.api.esb.gatewayUrl}ws/v1/mobile/myaccount/emailsignup/${this.chain.storeId}`;

		return this.http.post(url, reqData, httpOptions).pipe(
			map((response: any) => {
				// Return the raw data
				return response;
			}),
			retry(retries)
		);
	}

	/**
	 * @desc Registers the given email address with Loyalty.
	 *
	 * @param email - The email address that gets registered with Loyalty
	 * @param retries - number of retries
	 * @returns - {Observable<any>} Future Object to be resolved or rejected
	 */
	public registerEmailAddressForLoyalty$(email, retries = 0) {
		const reqData = {
			email_address: email
		};

		// HTTP Headers
		const httpHeaders = new HttpHeaders({
			'Content-Type': 'application/json'
		});

		// HTTP Options
		const httpOptions: { headers; observe } = {
			headers: httpHeaders,
			observe: 'response'
		};

		const url = `${this.chain.metaCanonical}/athleterecord/services/emailsignup`;

		return this.http.post(url, reqData, httpOptions).pipe(
			map((response: any) => {
				// Return the raw data
				return response.status;
			}),
			retry(retries)
		);
	}
}
